<template>
    <div class="cms_fullwidth_lane" :cms_listname="listname" v-show="LIST.length>0">
        <GrcDB ref="GRCDB"></GrcDB>
        <div class="cms_maincont_lane" style="text-align:center">
            <div  v-for="(item, index) in LIST" :key="index" class="bloglist_container">
                <div class="bloglist_item">
                    <div class="bloglist_textcont">
                        <div class="bloglist_title" v-html="item.Title" />
                        <div class="bloglist_content" v-html="item.ShortContent" />
                    </div>
                    <div class="bloglist_button_cont">
                        <a :href="item.LinkUrl" :class="['cms_button', item.ReadButtonStyle]">{{item.ReadButtonText}}</a>
                    </div>
                </div>
            </div>
            <div class="bloglist_allblog_btn_cont" v-show="allblog_show==1">
                <a :href="allblog_linkurl" :class="['cms_button', allblog_linkstyle]">{{allblog_buttontext}}</a>
            </div>
        </div>
    </div>
</template>

<script>

import GrcDB from './GrcDB.vue'

export default {
  name: 'grccms_bloglist',
  components: {
    GrcDB,
  },
  props: {
    cms_listname: String
  },

  data () {
        return {
            listname: this.cms_listname,
            LIST:[],
            allblog_linkurl:"",
            allblog_linkstyle:"",
            allblog_buttontext:"",
            allblog_show:0,
        }
  },
  model: {

  },  
  methods:{

    async Init()
    {
        var QP = {
            sSessionID: "[APPSESSIONID]",
            sAlias: GRCAPP_GetParameters.ALIAS,
            sListName: this.listname,
        };
        var Q;
        await this.$refs.GRCDB.GetData("CMS_GetBlogList", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            console.log(Q);
            return;
        }

        this.LIST = Q.LIST;

        this.allblog_linkurl = Q.DATA[0].allblog_linkurl;
        this.allblog_linkstyle = Q.DATA[0].allblog_linkstyle
        this.allblog_buttontext = Q.DATA[0].allblog_buttontext;
        this.allblog_show = Q.DATA[0].allblog_show;

    },

  },
  created()
  {
    if (typeof this.listname == "undefined")
    {
      this.listname = "";
    }

    if (this.listname == "") { return; }
    
  },

 mounted()
 {
    this.Init();
 },


}


</script>


<style scoped>


</style>
